module.exports = __webpack_public_path__ + "img/logo.c8967aed.svg";